import Backdrop from "@mui/material/Backdrop";
import Fade from "@mui/material/Fade";
import MuiModal, { type ModalProps } from "@mui/material/Modal";

type BaseModalProps = {
  open: boolean;
  disableBackdropBlur?: boolean;
} & Omit<ModalProps, "closeAfterTransition" | "slots" | "slotProps" | "style">;

export const BaseModal = ({ children, disableBackdropBlur, ...props }: BaseModalProps) => {
  return (
    <MuiModal
      {...props}
      disableRestoreFocus
      closeAfterTransition
      slots={{ backdrop: Backdrop }}
      slotProps={
        disableBackdropBlur
          ? {}
          : {
              backdrop: {
                timeout: 500,
                style: {
                  backgroundColor: "#1A192DCC",
                },
              },
            }
      }
    >
      <Fade in={props.open} timeout={500}>
        <div className="supportsRtl">{children}</div>
      </Fade>
    </MuiModal>
  );
};
